import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { ACTIONS } from 'redux-api-call';
import { UPDATE_PHONE_BILL_API_ID } from '../../apiCalls/adminPhoneBill/edit';
import routerHistory from '../../routerHistory';

const handleEditWithdrawalSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(
      flow(
        get('payload.name'),
        eq(UPDATE_PHONE_BILL_API_ID)
      )
    ),
    map(action => {
      const bill = get('payload.json.phone_bill')(action);
      routerHistory.push(`/billings/phone/${bill.id}`);
    })
  );

export default combineEpics(handleEditWithdrawalSuccess);
